import { Config } from "./common/settings/config.es6";
import Slider from "./common/classes/slider.es6";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const BREAKPOINT = Config.WINDOW_WIDTH;

export default class Character {
    constructor() {
        this.init();
    }

    init() {
        this.ListSlider();
        this.hoverLlist();
        this.switchCategory();
        this.referrerCheckAndShowList();
        this.showDetailList();
        this.hideAndShowPagenateion();
    }

    ListSlider() {
        const characterLists = document.querySelectorAll(".js-character-detail-list");

        if (!characterLists.length) return;

        this.sliders = [];

        const initSwiper = () => {
            const isPC = window.matchMedia(`(min-width: ${BREAKPOINT}px)`).matches;

            if (isPC) {
                // PC：Swiper破棄
                if (this.sliders.length) {
                    this.sliders.forEach((slider) => {
                        if (slider && slider.swiperInstance && typeof slider.swiperInstance.destroy === "function") {
                            slider.swiperInstance.destroy(true, true);
                            slider.swiperInstance = null;
                        } else if (slider && typeof slider.destroy === "function") {
                            slider.destroy(true, true);
                        }
                    });
                    this.sliders = [];
                }
            } else {
                // SP：Swiper初期化
                if (!this.sliders.length) {
                    characterLists.forEach((list) => {
                        // activeスライドのインデックスを取得
                        const slides = list.querySelectorAll(".swiper-slide");
                        let activeIndex = 0;
                        slides.forEach((slide, i) => {
                            if (slide.classList.contains("-active")) activeIndex = i;
                        });

                        const options = {
                            slidesPerView: 5.2,
                            spaceBetween: 4,
                            freeMode: true,
                            touchAngle: 45,
                            threshold: 5,
                            loop: false,
                            touchEventsTarget: "container",
                            breakpoints: {
                                [BREAKPOINT]: {
                                    slidesPerView: "auto",
                                    spaceBetween: 2,
                                    centerInsufficientSlides: true,
                                },
                            },
                        };

                        const slider = new Slider(list, options);
                        this.sliders.push(slider);

                        // activeが画面外なら見える位置までスライド（右端に収まる位置）
                        if (slider.swiperInstance && activeIndex > 0) {
                            const swiper = slider.swiperInstance;
                            const visibleCount = Math.floor(swiper.params.slidesPerView);

                            if (activeIndex >= visibleCount) {
                                const targetIndex = activeIndex - visibleCount + 1;
                                requestAnimationFrame(() => {
                                    swiper.slideTo(targetIndex, 0);
                                });
                            }
                        }
                    });
                }
            }
        };

        initSwiper();

        window.addEventListener("resize", initSwiper);
    }

    hoverLlist() {
        const characterLists = document.querySelectorAll(".js-character-list");

        if (!characterLists) return;

        characterLists.forEach((list) => {
            const items = [...list.querySelectorAll(".character__list__item")];

            items.forEach((item) => {
                item.addEventListener("mouseenter", () => {
                    list.classList.add("-hover");
                });

                item.addEventListener("mouseleave", () => {
                    list.classList.remove("-hover");
                });
            });
        });
    }

    switchCategory() {
        const switchBtns = document.querySelectorAll(".js-list-category-item");
        const selectCont = document.querySelector(".js-character-select");
        this.isSwitch = false;

        switchBtns.forEach((btn) => {
            btn.addEventListener("click", () => {
                const categoryId = btn.getAttribute("data-category");
                sessionStorage.setItem("yominotsugai_character", categoryId);

                if (selectCont) {
                    selectCont.setAttribute("data-category", categoryId);

                    if (!this.isSwitch) {
                        selectCont.classList.add("-switched");
                    }
                } else {
                    document.body.setAttribute("data-category", categoryId);
                }
            });
        });
    }

    referrerCheckAndShowList() {
        const referrer = document.referrer;
    
        if (!referrer) {
            document.body.classList.add("-firstview");
            return;
        }
    
        const refUrl = new URL(referrer, location.origin);
        const refPath = refUrl.pathname;
    
        const isFromCharacter = refPath.startsWith("/character/");
        const isFromIndex = refPath === "/character/" || refPath === "/character/index.html";
    
        if (!isFromCharacter) {
            document.body.classList.add("-firstview");
        } else if (isFromIndex) {
            document.body.classList.add("-from-list");
        } else {
            document.body.classList.add("-from-detail");
        }
    }

    showDetailList() {
        const characterHandleCont = document.querySelector(".js-scroll-list");
        if (!characterHandleCont) return;
    
        const getStart = () => {
            const isLowHeight = window.innerHeight <= 700;
            return isLowHeight ? "top 60%" : "top bottom";
        };
    
        this.detailTrigger = ScrollTrigger.create({
            trigger: characterHandleCont,
            start: getStart,
            invalidateOnRefresh: true,
            onEnter: () => document.body.classList.add("-character-top"),
            onEnterBack: () => document.body.classList.add("-character-top"),
            onLeaveBack: () => document.body.classList.remove("-character-top"),
        });
    
        window.addEventListener("resize", () => {
            ScrollTrigger.refresh();
        });
    }

    hideAndShowPagenateion() {
        const pagination = document.querySelector(".character__pagenation");
        const charaList = document.querySelector(".js-character-select");

        if (!pagination || !charaList) return;

        const mm = gsap.matchMedia();

        mm.add(
            {
                isPC: `(min-width: ${BREAKPOINT}px)`,
                isSP: `(max-width: ${BREAKPOINT - 1}px)`,
            },
            (context) => {
                const { isPC } = context.conditions;

                ScrollTrigger.create({
                    trigger: charaList,
                    start: isPC ? "top 20%" : "top 50%",
                    //markers: true,
                    onEnter: () => document.body.classList.add("-hide-pagenate"),
                    onLeaveBack: () => document.body.classList.remove("-hide-pagenate"),
                });
            }
        );
    }
}

const character = new Character();
